import { format } from "date-fns";
import React, { useState, useEffect, useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Row, Col } from "react-bootstrap";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import SpecialNIPL from "../../../assets/icons/SpecialNIPL";
import ModalLayout from "../../../containers/Layouts/ModalLayout/ModalLayout";
import withAuth from "../../../services/withAuthProvider";
import SettingTransaksiBayar from "../../Modal/SettingTransaksiBayar/SettingTransaksiBayar";
import MoreButton from "../../MoreButton/MoreButton";
import { SkeletonTransaction } from "../../Skeleton/Skeleton";
import NoImage from "../../../assets/images/NoImage.jpg";

const defaultImage = NoImage;

const ChildPurchase = (props) => {
  const detail = props.data || {};

  function renderStatus(param) {
    switch (param) {
      case "PENDING":
        return "<span class='badge-status warning'>Menunggu Pembayaran</span>";
      case "PAID":
        return "<span class='badge-status success'>Lunas</span>";
      case "WANPRESTASI":
        return "<span class='badge-status danger'>Wanprestasi</span>";
      case "OVERPAID":
        return "<span class='badge-status danger'>Overpaid</span>";
      default:
        return "";
    }
  }

  // Safe date formatting function
  const formatDate = (dateString) => {
    try {
      if (!dateString) return "-";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";
      return format(date, "dd MMM yyyy, HH:mm") + " WIB";
    } catch (error) {
      console.warn("Date formatting error:", error);
      return "-";
    }
  };

  // Safe number formatting function
  const formatNumber = (number) => {
    try {
      if (!number || isNaN(number)) return "-";
      return Number(number).toLocaleString();
    } catch (error) {
      console.warn("Number formatting error:", error);
      return "-";
    }
  };
  return (
    <div className="card-transaksi position-relative">
      <div className="header">
        <Row>
          <div className="col-md-6">
            <span className="title d-none d-sm-block mb-2">No.Invoice</span>
            <span className="value invoice-number">{detail?.transaction_number}</span>
          </div>
          <div className="col-md-3">
            <span className="title d-none d-sm-block mb-2">Tanggal Pembelian</span>
            <span className="value">{formatDate(detail?.created_at)}</span>
          </div>
          <div className="col-md-3">
            <span className="title d-none d-sm-block mb-2">Status</span>
            <span
              className="value"
              dangerouslySetInnerHTML={{
                __html: renderStatus(detail?.result?.result_selling || ""),
              }}
            ></span>
          </div>
        </Row>
      </div>
      <div className="body">
        <Row>
          <Col md={6}>
            <div className="d-flex info-unit">
              <div>
                <div
                  className="unit-image"
                  style={
                    detail?.stock_unit?.pictures?.length > 0 && detail?.stock_unit?.pictures[0]?.image_url
                      ? {
                          position: "relative",
                          float: "left",
                          background: `url("${detail?.stock_unit?.pictures[0].image_url}")`,
                        }
                      : {
                          position: "relative",
                          float: "left",
                          background: `url(${defaultImage})`,
                        }
                  }
                ></div>
              </div>
              <div style={{ marginLeft: "10px" }}>
                <div className="unit-name">
                  {detail?.stock_unit?.unit_name ||
                    `${detail?.stock_unit?.year || ""} ${detail?.stock_unit?.unit_maker?.name || ""} ${
                      detail?.stock_unit?.unit_model?.name || ""
                    }`.trim() ||
                    "Unit tidak tersedia"}
                </div>
                <span className="title">Harga Final</span>
                <br />
                <span className="harga final">Rp {formatNumber(detail?.final_price)}</span>
                <br />
                {detail?.result?.number_of_nipl > 1 && (
                  <span className="nomor-lot nipl">
                    <span className="icon-nipl">
                      <SpecialNIPL />
                    </span>
                    Special NIPL
                    {/* <span className='text orange'>
                    </span> */}
                  </span>
                )}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="row info-tagihan">
              <div className="col-md-6">
                <span className="title">Total Tagihan</span>
                <br />
                <span className="harga tagihan">Rp {formatNumber(detail?.grand_total)}</span>
                <br />
                <span className="title">Tanggal Kedaluwarsa</span>
                <br />
                <span className="tanggal">{formatDate(detail?.expiry_date)}</span>
              </div>
              <div className="col-md-6 button">
                {
                  // detail?.payment_bank_name !== null &&
                  // detail?.payment_bank_virtual_account !== null &&
                  detail?.status !== "PAID" &&
                  detail?.result?.result_selling !== "WANPRESTASI" &&
                  detail?.result?.result_selling !== "PAID" ? (
                    <a className="btn-bayar cursor-pointer disable-copy" onClick={props.openModal}>
                      Bayar
                    </a>
                  ) : (
                    ""
                  )
                }
                <a className="btn-detail cursor-pointer disable-copy" onClick={props.onClick}>
                  Lihat detail ringkasan
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const PurchaseTransactionContent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState({});
  const [transaction, setTransaction] = useState();
  /* const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paginate, setPaginate] = useState({ ...initialPaginate }); */
  const [isVirtualAccountReady, setIsVirtualAccountReady] = useState(true);
  const { push } = useHistory();

  const closeModal = () => {
    setIsOpen(false);
    setTransaction();
    setIsVirtualAccountReady(true);
  };

  const {
    data: queryData,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ["purchaseTransactions"],
    async ({ pageParam = 1 }) => {
      const response = await withAuth.getDataWithAuth("/api/trx-invoice-unit/transaction/unit", {
        page: pageParam,
        page_size: 5,
      });
      if (response?.status === 200) {
        return response.data.data;
      }
      throw new Error(response?.data?.message || "Terjadi kesalahan saat mengambil data");
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page < lastPage.last_page) {
          return lastPage.current_page + 1;
        }
        return undefined;
      },
      keepPreviousData: true,
      onError: (err) => {
        toast.error(err.message);
      },
    }
  );

  const data = useMemo(() => {
    return queryData?.pages?.flatMap((page) => page.data) || [];
  }, [queryData]);

  useEffect(() => {
    if (transaction && Array.isArray(data)) {
      const trx = data.find((purchase) => purchase?.id === parseInt(transaction));
      if (typeof trx !== "undefined") {
        setIsOpen(true);
        setDetail(trx);

        // Check if virtual account is ready
        const hasVirtualAccount = trx?.payment_bank_name && trx?.payment_bank_virtual_account;
        setIsVirtualAccountReady(!!hasVirtualAccount);
      }
    }
  }, [transaction, data]);

  // Auto-refresh data every 10 seconds only when modal is open and virtual account is not ready
  useEffect(() => {
    // Jangan auto-refresh jika CLOSE-BID dengan non_deposit = 1
    const isCloseBidNonDeposit =
      detail?.auction?.auction_category === "CLOSE-BID" && detail?.auction?.is_non_deposit === 1;

    // Only start interval if modal is open and virtual account is not ready and not CLOSE-BID non-deposit
    if (!isOpen || isVirtualAccountReady || isCloseBidNonDeposit) {
      return;
    }

    const intervalId = setInterval(() => {
      // Refresh data without showing loading state
      const refreshData = async () => {
        try {
          // Re-fetch logic simplified to just updated checking the modal detail if possible,
          // or we can manually trigger a refetch of the list if needed,
          // but for now let's keep the logic similar but targeting the specific endpoint or simplified.
          // Since we migrated to React Query, let's just re-fetch the specific page or invalidating the query might be cleaner but resets list.
          // For now, let's just fetch the full list manually to update state if we want to mimic old behavior,
          // OR better: fetch the specific transaction detail by ID if API supports it.
          // Assuming we stick to the old "fetch everything" approach for consistency within this refactor:

          const params = {
            page: 1,
            page_size: (queryData?.pages?.length || 1) * 5, // Get all previously loaded data
          };

          const response = await withAuth.getDataWithAuth("/api/trx-invoice-unit/transaction/unit", params);
          if (response?.status === 200) {
            const res = response?.data?.data;
            if (res && Array.isArray(res.data)) {
              // setData(res.data); // We can't set data directly like this with useInfiniteQuery easily without cache manipulation.
              // Instead of manually setting data, we can rely on checking the specific item in the response

              const updatedList = res.data;

              // Update detail if modal is open
              if (transaction) {
                const updatedTrx = updatedList.find((purchase) => purchase?.id === parseInt(transaction));
                if (updatedTrx) {
                  setDetail(updatedTrx);

                  // Check if virtual account is now ready
                  const hasVirtualAccount = updatedTrx?.payment_bank_name && updatedTrx?.payment_bank_virtual_account;
                  setIsVirtualAccountReady(!!hasVirtualAccount);
                }
              }
            }
          }
        } catch (error) {
          console.error("Error refreshing data:", error);
        }
      };

      refreshData();
    }, 10000); // 10 seconds

    return () => clearInterval(intervalId);
  }, [
    queryData,
    transaction,
    isOpen,
    isVirtualAccountReady,
    detail?.auction?.auction_category,
    detail?.auction?.is_non_deposit,
  ]);

  return (
    <>
      <Row>
        {isLoading ? (
          new Array(3).fill(1).map((el, idx) => (
            <div key={idx}>
              <SkeletonTransaction />
            </div>
          ))
        ) : (
          <>
            {/* <Col>
              <Alert key={"alert"} variant={"info"}>
                <div className="text-center">
                  Refresh halaman secara berkala untuk mendapatkan data transaksi terbaru
                </div>
              </Alert>
            </Col> */}
            {Array.isArray(data) &&
              data.map((el, idx) => (
                <Col key={el?.id || idx} md={12}>
                  <ChildPurchase
                    data={el}
                    onClick={() => el?.id && push("/pengaturan/transaksi/pembelian/" + el.id)}
                    openModal={() => el?.id && setTransaction(el.id)}
                  />
                </Col>
              ))}
          </>
        )}
        {hasNextPage && <MoreButton onClick={() => fetchNextPage()} loading={isFetchingNextPage} />}
        {Array.isArray(data) && data.length === 0 && isLoading === false && (
          <div className="px-3 py-2 font-sm text-center text-secondary w-100">Tidak ada transaksi</div>
        )}
      </Row>
      <ModalLayout show={isOpen} handleClose={closeModal} title="Menunggu Pembayaran" className="">
        {!isVirtualAccountReady &&
        !(detail?.auction?.auction_category === "CLOSE-BID" && detail?.auction?.is_non_deposit === 1) ? (
          <div className="text-center py-5">
            <div className="d-flex justify-content-center align-items-center mb-4">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              ></div>
            </div>
            <h5 className="mb-3">Pembayaran Sedang Diproses</h5>
            <p className="text-muted mb-2">
              Mohon tunggu beberapa saat, kami sedang memproses informasi pembayaran Anda.
            </p>
          </div>
        ) : (
          <SettingTransaksiBayar data={detail} />
        )}
      </ModalLayout>
    </>
  );
};

export default PurchaseTransactionContent;
